import { useMutation } from "@tanstack/react-query";
import {
  deleteSkillsFramework,
  DeleteSkillsFrameworkResponse
} from "PFCore/services/admin/skills_frameworks/delete_skills_framework";
import { MutationOptions } from "PFTypes/request_options";

import { useSkillsFrameworksInvalidate } from "../../skills_frameworks/use_skills_frameworks_invalidate";
import { useAdminSkillsFrameworksInvalidate } from "./use_skills_frameworks_invalidate";

type UseSkillsFrameworkDelete = {
  options?: MutationOptions<DeleteSkillsFrameworkResponse>;
};

export const useSkillsFrameworkDelete = ({ options = {} }: UseSkillsFrameworkDelete = {}) => {
  const { invalidateAll } = useSkillsFrameworksInvalidate();
  const { invalidateList } = useAdminSkillsFrameworksInvalidate();

  return useMutation<DeleteSkillsFrameworkResponse, unknown, any>({
    mutationFn: deleteSkillsFramework,
    onSuccess: (...args) => {
      invalidateAll();
      invalidateList();
      options.onSuccess?.(...args);
    },
    ...options
  });
};
